import { useEffect, useReducer } from 'react';
import FormData from 'form-data';
import { viewEmployeesAction } from 'api/employees';

const initialState = {
  isLoading: false,
  data: {},
  error: null,
};

const reducer = (state, action) => {
  const { type, payload } = action;
  let newState;
  switch (type) {
    case 'pending': {
      newState = { ...state, isLoading: true };
      break;
    }
    case 'resolved': {
      newState = { ...state, isLoading: false, data: payload };
      break;
    }
    case 'rejected': {
      newState = { ...state, isLoading: false, error: payload };
      break;
    }
    default: {
      newState = state;
    }
  }
  return newState;
};

const useFetchEmployee = (userId) => {
  const [employee, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const fetchEmployeeById = async () => {
      dispatch({ type: 'pending' });
      const bodyFormData = new FormData();
      bodyFormData.append('id', userId);
      try {
        const response = await viewEmployeesAction(bodyFormData);
        if (response) {
          dispatch({ type: 'resolved', payload: response });
        }
      } catch (error) {
        dispatch({ type: 'rejected', payload: error });
      }
    };
    fetchEmployeeById();
  }, [userId]);

  return [employee];
};

export default useFetchEmployee;
